import { ConditionStatusScrollState } from '@/configuration/internal-redirect-states/condition-status-scroll-state'
import { MeasurementType } from '@/configuration/measurements/measurement-types'
import { defineStore } from 'pinia'
import { reactive } from 'vue'

export const useConditionStatusCollapseStore = defineStore('generatorConditionStatusCollapseStore', () => {
    const collapsedState = reactive({
        recommendations: { collapsed: true },
        measurements: { collapsed: true, selectedMeasurement: MeasurementType.WindingResistance },
        visualInspections: { collapsed: true },
        analysisComments: { collapsed: true },
        generalComments: { collapsed: true },
        historicalTrends: { collapsed: true }
    })

    const setCollapseScrollState = (state: ConditionStatusScrollState) => {
        switch (state) {
            case ConditionStatusScrollState.Recommendations:
                collapsedState.recommendations.collapsed = false
                break
            case ConditionStatusScrollState.AnalysisComments:
                collapsedState.analysisComments.collapsed = false
                break
            case ConditionStatusScrollState.VisualInspection:
                collapsedState.visualInspections.collapsed = false
                break
            case ConditionStatusScrollState.ComponentComments:
                collapsedState.generalComments.collapsed = false
                break
            case ConditionStatusScrollState.Default:
                break
        }
    }

    const resetCollapsedState = () => {
        collapsedState.recommendations = { collapsed: true }
        collapsedState.measurements = { collapsed: true, selectedMeasurement: MeasurementType.WindingResistance }
        collapsedState.visualInspections = { collapsed: true }
        collapsedState.analysisComments = { collapsed: true }
        collapsedState.generalComments = { collapsed: true }
        collapsedState.historicalTrends = { collapsed: true }
    }

    return {
        collapsedState,
        setCollapseScrollState,
        resetCollapsedState,
    }
})
